import { render, staticRenderFns } from "./OrgPersonTreeSelect.vue?vue&type=template&id=ba7437c2&scoped=true"
import script from "./OrgPersonTreeSelect.vue?vue&type=script&lang=js"
export * from "./OrgPersonTreeSelect.vue?vue&type=script&lang=js"
import style0 from "./OrgPersonTreeSelect.vue?vue&type=style&index=0&id=ba7437c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba7437c2",
  null
  
)

export default component.exports